export default {"src":"/_next/static/media/logo.a7bd82db.svg","height":500,"width":500};